import { render, staticRenderFns } from "./ProgrammaticTargetParsersList.vue?vue&type=template&id=b0a1ffd0&scoped=true"
import script from "./ProgrammaticTargetParsersList.vue?vue&type=script&lang=js"
export * from "./ProgrammaticTargetParsersList.vue?vue&type=script&lang=js"
import style0 from "./ProgrammaticTargetParsersList.vue?vue&type=style&index=0&id=b0a1ffd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a1ffd0",
  null
  
)

export default component.exports